import script from "./TelegramUserSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramUserSettings.vue?vue&type=script&setup=true&lang=js"

import "./TelegramUserSettings.vue?vue&type=style&index=0&id=5682b968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5682b968"]])

export default __exports__